/* 🤖 this file was generated by svg-to-ts */
export const matIconFemale: {
  name: 'female';
  data: string;
} = {
  name: 'female',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M17.5 9.5C17.5 6.46 15.04 4 12 4S6.5 6.46 6.5 9.5c0 2.7 1.94 4.93 4.5 5.4V17H9v2h2v2h2v-2h2v-2h-2v-2.1c2.56-.47 4.5-2.7 4.5-5.4zm-9 0C8.5 7.57 10.07 6 12 6s3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5z"/></svg>`
};
